// src/pages/PrivacyPolicyPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";

function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <motion.div
      style={containerStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        style={cardStyle}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <h1 style={titleStyle}>Gizlilik Politikası</h1>
        <div style={contentContainerStyle}>
          <motion.p
            style={introTextStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Yelken olarak, kullanıcılarımızın gizliliğine büyük önem veriyoruz. Bu Gizlilik Politikası, kişisel bilgilerinizin nasıl toplandığını, kullanıldığını, korunduğunu ve paylaşıldığını açıklamaktadır. Hizmetlerimizi kullanarak, bu politikayı kabul etmiş sayılırsınız.
          </motion.p>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>1. Topladığımız Bilgiler</h2>
            <p style={sectionTextStyle}>
              Yelken platformunu kullanırken aşağıdaki bilgileri toplayabiliriz:
            </p>
            <ul style={listStyle}>
              <li>Kayıt sırasında sağladığınız bilgiler (ad, e-posta adresi, kullanıcı adı vb.).</li>
              <li>Çalışma verileriniz (hedefler, çalışma süreleri, tamamlanan görevler).</li>
              <li>İletişim bilgileriniz (mesajlaşma ve forum etkileşimleri).</li>
              <li>Teknik bilgiler (IP adresi, cihaz türü, tarayıcı bilgileri).</li>
            </ul>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>2. Bilgilerin Kullanımı</h2>
            <p style={sectionTextStyle}>
              Topladığımız bilgileri şu amaçlarla kullanırız:
            </p>
            <ul style={listStyle}>
              <li>Hizmetlerimizi sunmak ve geliştirmek.</li>
              <li>Kullanıcı deneyiminizi kişiselleştirmek.</li>
              <li>İletişim kurmak (bildirimler, güncellemeler).</li>
              <li>Güvenlik ve dolandırıcılığı önleme amaçlarıyla analiz yapmak.</li>
            </ul>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>3. Bilgilerin Paylaşımı</h2>
            <p style={sectionTextStyle}>
              Kişisel bilgileriniz, aşağıdaki durumlar dışında üçüncü taraflarla paylaşılmaz:
            </p>
            <ul style={listStyle}>
              <li>Yasal zorunluluklar veya mahkeme kararları gerektirdiğinde.</li>
              <li>Hizmet sağlayıcılarımızla (örneğin, ödeme işlemcileri) yalnızca hizmet sunumu için.</li>
              <li>Kullanıcı izniyle (örneğin, sosyal özelliklerde diğer kullanıcılarla paylaşım).</li>
            </ul>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>4. Veri Güvenliği</h2>
            <p style={sectionTextStyle}>
              Bilgilerinizin güvenliğini sağlamak için endüstri standardı güvenlik önlemleri alıyoruz. Ancak, internet üzerinden veri iletiminin tamamen güvenli olmadığını unutmayın. Bu nedenle, kişisel bilgilerinizi paylaşırken dikkatli olmanızı öneririz.
            </p>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>5. Çerezler</h2>
            <p style={sectionTextStyle}>
              Platformumuz, kullanıcı deneyimini iyileştirmek için çerezler kullanır. Çerezleri, oturum yönetimi, analiz ve kişiselleştirme amacıyla kullanırız. Tarayıcı ayarlarınızı değiştirerek çerez kullanımını reddedebilirsiniz.
            </p>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>6. Haklarınız</h2>
            <p style={sectionTextStyle}>
              Kişisel verilerinizle ilgili aşağıdaki haklara sahipsiniz:
            </p>
            <ul style={listStyle}>
              <li>Verilerinize erişim talep etme.</li>
              <li>Verilerinizin düzeltilmesini veya silinmesini isteme.</li>
              <li>Veri işleme faaliyetlerine itiraz etme.</li>
              <li>Verilerinizin taşınabilirliğini talep etme.</li>
            </ul>
            <p style={sectionTextStyle}>
              Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.
            </p>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>7. Değişiklikler</h2>
            <p style={sectionTextStyle}>
              Bu Gizlilik Politikası zaman zaman güncellenebilir. Değişiklikler yapıldığında, güncellenmiş politikayı platformumuzda yayınlayacağız ve sizi bilgilendireceğiz. Politikayı düzenli olarak gözden geçirmenizi öneririz.
            </p>
          </motion.div>

          <motion.div
            style={sectionStyle}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.0, duration: 0.5 }}
          >
            <h2 style={sectionTitleStyle}>8. İletişim</h2>
            <p style={sectionTextStyle}>
              Gizlilik Politikamızla ilgili sorularınız veya endişeleriniz varsa, bizimle iletişime geçebilirsiniz:
            </p>
            <p style={contactTextStyle}>
              <strong>E-posta:</strong> destek@yelkenapp.com <br />
              <strong>Adres:</strong> Yelken Teknoloji A.Ş., İstanbul, Türkiye <br />
              <strong>Yetkili:</strong> Emre Taşşakkan & Habib Burhan Can
            </p>
          </motion.div>
        </div>

        <motion.button
          onClick={() => navigate(-1)}
          style={backButtonStyle}
          whileHover={{ scale: 1.05, backgroundColor: "#00c853" }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.2 }}
        >
          Geri Dön
        </motion.button>
      </motion.div>
    </motion.div>
  );
}

const containerStyle = {
  background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  overflow: 'auto',
  fontFamily: "'Inter', sans-serif",
  padding: "40px",
};

const cardStyle = {
  background: 'rgba(255, 255, 255, 0.05)',
  padding: '40px',
  borderRadius: '12px',
  boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
  border: "1px solid rgba(0, 230, 118, 0.2)",
  width: '100%',
  maxWidth: '800px',
  textAlign: 'left',
  position: 'relative',
  zIndex: 1,
};

const titleStyle = {
  fontSize: '28px',
  marginBottom: '30px',
  color: '#00e676',
  fontWeight: 'bold',
  textShadow: "0 0 10px rgba(0, 230, 118, 0.3)",
  textAlign: 'center',
};

const contentContainerStyle = {
  maxHeight: "60vh",
  overflowY: "auto",
  paddingRight: "10px",
};

const introTextStyle = {
  fontSize: '16px',
  color: '#f0f0f0',
  marginBottom: '30px',
  lineHeight: '1.6',
};

const sectionStyle = {
  marginBottom: '30px',
};

const sectionTitleStyle = {
  fontSize: '20px',
  color: '#00ffcc',
  marginBottom: '15px',
  borderBottom: "1px solid rgba(0, 230, 118, 0.2)",
  paddingBottom: "5px",
};

const sectionTextStyle = {
  fontSize: '14px',
  color: '#b0bec5',
  lineHeight: '1.6',
  marginBottom: '10px',
};

const listStyle = {
  listStyleType: 'disc',
  paddingLeft: '20px',
  marginBottom: '10px',
};

const contactTextStyle = {
  fontSize: '14px',
  color: '#f0f0f0',
  lineHeight: '1.6',
};

const backButtonStyle = {
  background: 'linear-gradient(135deg, #00e676, #00c853)',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 24px',
  fontSize: '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'block',
  margin: '20px auto 0',
};

export default PrivacyPolicyPage;